<nb-card>
  <nb-card-header>
    Bereichsinformationen
  </nb-card-header>
  <nb-card-body *ngIf="region() as region">
    <div class="detail-body">
      <div class="left">
        <div>
          <label class="label">Teamname</label>
          <span>{{ region.name }}</span>
        </div>
        <div>
          <label class="label">Teamleiter</label>
          <span>{{ region.leader.fullName }}</span>
        </div>
        <div>
          <label class="label">Anzahl der Teams</label>
          <span>{{ region.teamCount }}</span>
        </div>
        <div>
          <label class="label">Fläche</label>
          <span>{{ region.totalArea | number:'1.2-2' }} m²</span>
        </div>
      </div>
      <div class="right">
        <div>
          <label class="label">Teamkürzel</label>
          <span>{{ region.abbreviation }}</span>
        </div>
        <div>
          <label class="label">Dienstleister</label>
          <span>{{ region.tenant.name }}</span>
        </div>
        <div>
          <label class="label">Anzahl der Teammitglieder</label>
          <span>{{ region.userCount }}</span>
        </div>
        <div class="flex-grow"></div>
        <button nbButton fullWidth status="basic" (click)="editRegion(region)">
          <span>Bereich bearbeiten</span>
          <nb-icon icon="external-link-outline" pack="eva"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
